/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { BasicAlert } from '../alert/BasicAlert';
import { RegisterInterestForm, RegisterInterestFormProps } from '../../routes/home/partials/RegisterInterestForm';

type PassThroughProps = Pick<RegisterInterestFormProps, 'interestedIn' | 'productCode'>;

interface RequestDemoModalProps extends PassThroughProps {
  toggle: () => void;
  isOpen: boolean;
  title?: string | JSX.Element;
  onSubmit?: () => unknown;
}

const RequestDemoModal = (props: RequestDemoModalProps) => {
  const { toggle, isOpen, title = 'Contact us', onSubmit, ...rest } = props;
  const [submitMessage, setSubmitMessage] = useState<undefined | string>(undefined);

  const onModalSubmit = () => {
    setSubmitMessage('Message sent. We’ll be in touch shortly.');
    setTimeout(async () => {
      toggle();
      if (onSubmit) {
        await onSubmit()
      }
    }, 2000);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop='static' className='request-demo-modal'>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <BasicAlert type={'success'}>{submitMessage}</BasicAlert>
        <RegisterInterestForm title={''} onSubmit={onModalSubmit} { ...rest } />
      </ModalBody>
    </Modal>
  );
}

export default RequestDemoModal;
